import { CartMinusIcon } from './CartMinusIcon';

/**
 * author: Simran
 * id D4AF47D5-214B-4856-8450-0ED7C524991D
 * name cart-minus
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-minus.svg
 * tags
 * - Shopping 
 */
export const TrolleyMinusIcon = CartMinusIcon;
export default TrolleyMinusIcon